module.exports = __webpack_public_path__ + "static/media/CopyWhite.88b8d606.svg";